import React, { useEffect, useState } from 'react'
import { Helmet } from "react-helmet-async";
import { Get_Api } from '../Api_Url';

function GetSeodata({ PageName }) {
    const [IsUploading, setIsUploading] = useState(false);
    const [Data, setData] = useState({});

    const GetASEOData = async () => {
        try {
            setIsUploading(true)
            const response = await Get_Api(`api/admin/GetASEODetails/${PageName}`)
            setData(response?.data)
            setIsUploading(false)
        } catch (error) {
            setIsUploading(false)
            console.log(error)
        }
    }

    useEffect(() => {
        GetASEOData();
    }, [PageName]);


    return (
        <div>
            <Helmet>
                <title>{Data?.MetaTitle}</title>
                <meta
                    name="description"
                    content={Data?.MetaDescription}
                />
                {Data?.MetaTags?.map((tag, index) => (
                    <meta key={index} name="keywords" content={tag} />
                ))}
            </Helmet>

        </div>
    )
}

export default GetSeodata